module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content preview"
  }, [_c('nav', {
    staticClass: "sum"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('prediction')) + "\n            "), (_vm.voteData.total_num) ? [_vm._v(_vm._s(_vm.$tc('voteNum', 10, {
    count: _vm.voteData.total_num
  })))] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.voteData.name && _vm.isShowOverview) ? _c('p', {
    staticClass: "forecast"
  }, [_vm._v(_vm._s(_vm.voteData.name))]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "vote_con"
  }, _vm._l((_vm.voteData.data), function(item) {
    return _c('li', {
      key: item.id
    }, [_c('div', {
      staticClass: "vote_view",
      attrs: {
        "id": item.name.toLowerCase(),
        "data-vote": "1"
      }
    }, [_c('div', {
      staticClass: "vote_box"
    }, [_c('div', {
      staticClass: "progress_con"
    }, [_c('div', {
      staticClass: "progress",
      style: ({
        'height': _vm.height(item.num) + 'px',
        'line-height': _vm.height(item.num) + 'px'
      })
    }, [_c('b', [_vm._v(_vm._s(item.percent) + "%")])])])]), _vm._v(" "), _c('div', {
      staticClass: "bottom_vote",
      class: {
        'clicked': !_vm.votable(item.id) || _vm.voted(item.id)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.vote(item.id)
        }
      }
    }, [_c('span'), _vm._v(" " + _vm._s(_vm.voted(item.id) ? _vm.$t('voted') : _vm.$t('vote')) + "\n                        ")]), _vm._v(" "), _c('p', [(item.id === 1) ? _c('img', {
      attrs: {
        "alt": "",
        "src": _vm.getImgSrc(_vm.homeImgSrc)
      }
    }) : _vm._e(), _vm._v(" "), (item.id === 3) ? _c('img', {
      attrs: {
        "alt": "",
        "src": _vm.getImgSrc(_vm.awayImgSrc)
      }
    }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t(item.name.toLowerCase())))])])])])
  }))]), _vm._v(" "), (_vm.analysisData) ? _c('past-games', {
    attrs: {
      "game-data": _vm.analysisData
    }
  }) : _c('skeleton'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "mask"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('matchNotStart')))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27ea61cc","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/matchAnalysis.vue
// module id = 672
// module chunks = 2